/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onNewMessage = /* GraphQL */ `
  subscription OnNewMessage($recipient: String) {
    onNewMessage(recipient: $recipient) {
      id
      content
      sender
      recipients
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage($filter: ModelSubscriptionMessageFilterInput) {
    onCreateMessage(filter: $filter) {
      id
      content
      sender
      recipients
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage($filter: ModelSubscriptionMessageFilterInput) {
    onUpdateMessage(filter: $filter) {
      id
      content
      sender
      recipients
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage($filter: ModelSubscriptionMessageFilterInput) {
    onDeleteMessage(filter: $filter) {
      id
      content
      sender
      recipients
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
